module.exports = __webpack_public_path__ + "assets/img/NPC009.cf28b970.png";